import {
  UserState,
  UserActionTypes,
  INITIALISE,
} from './Types';

const initialState: UserState = {
  user: {
    id: -1,
    username: '',
    author: {
      id: -1,
      name: '',
      position: '',
      image: -1,
    },
  },
};

export const userReducer = (state = initialState, action: UserActionTypes): UserState => {
  switch (action.type) {
  case INITIALISE:
    return {
      ...state,
      user: action.payload,
    };
  default:
    return state;
  }
};
